"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _default = _react.default.createClass({
  displayName: "ColorPickerShim",
  propTypes: {
    color: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    open: _react.PropTypes.bool.isRequired
  },
  componentDidMount: function componentDidMount() {
    this.open(this.props.open);
  },
  componentDidUpdate: function componentDidUpdate() {
    this.open(this.props.open);
  },
  open: function open(isOpen) {
    if (isOpen) {
      this._colorInput.click();
    }
  },
  colorInputRefCallback: function colorInputRefCallback(ref) {
    this._colorInput = ref;
  },
  render: function render() {
    var _this$props = this.props,
        color = _this$props.color,
        onChange = _this$props.onChange;
    return _react.default.createElement("input", {
      className: "hidden",
      type: "color",
      value: color,
      onChange: onChange,
      ref: this.colorInputRefCallback
    });
  }
});

exports.default = _default;
module.exports = exports.default;